import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import KvaPriceManager from './KvaPriceManager';
import { normalizeCompanyKey, firebaseCompanyKey } from '../../Utils/companyUtils';
import { ref, set, get } from 'firebase/database';
import { realtimeDb } from '../../firebase';

const KvaPricingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { division } = useParams();
  const rawCompany = location.state?.company || 'Sagar Power Lines';
  const normalizedCompany = normalizeCompanyKey(rawCompany);

  console.log('KvaPricingPage - Raw Company:', rawCompany, 'Normalized:', normalizedCompany, 'Division:', division);

  useEffect(() => {
    if (!normalizedCompany || !division) {
      console.error('Missing company or division:', { normalizedCompany, division });
      navigate('/admin/dashboard');
      return;
    }

    const sanitizedCompany = firebaseCompanyKey(normalizedCompany);
    const divisionPath = `companies/${sanitizedCompany}/divisions`;

    // Initialize division if it doesn't exist
    const initializeDivision = async () => {
      try {
        const divisionRef = ref(realtimeDb, divisionPath);
        const divisionSnapshot = await get(divisionRef);
        let divisions = divisionSnapshot.exists() ? divisionSnapshot.val() : [];
        if (!Array.isArray(divisions)) {
          divisions = divisions ? Object.values(divisions) : [];
        }
        if (!divisions.includes(division)) {
          console.log(`Adding new division "${division}" for company "${normalizedCompany}"`);
          await set(ref(realtimeDb, `${divisionPath}/${division}`), true);
          console.log(`Division "${division}" initialized successfully.`);

          // Initialize default KVA prices for new division
          const kvaPricesPath = `companies/${sanitizedCompany}/${division}/kvaPrices`;
          const defaultKvaPrices = {
            "100 KVA AMDT": 15000,
            "100 KVA CRGO": 12000,
            "65 KVA AMDT": 10000,
            "65 KVA CRGO": 8000
          };
          await set(ref(realtimeDb, kvaPricesPath), defaultKvaPrices);
          console.log(`Default KVA prices set for division "${division}"`);
        }
      } catch (error) {
        console.error('Error initializing division:', error);
        alert(`Failed to initialize division "${division}": ${error.message}`);
        navigate('/admin/dashboard');
      }
    };

    initializeDivision();
  }, [normalizedCompany, division, navigate]);

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">
          {division} – KVA Pricing ({normalizedCompany})
        </h2>
        <button
          onClick={() =>
            navigate(`/admin/division/${division}`, {
              state: { company: normalizedCompany },
            })
          }
          className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
        >
          ← Back to Division
        </button>
      </div>

      <KvaPriceManager
        selectedCompany={normalizedCompany}
        selectedDivision={division}
      />
    </div>
  );
};

export default KvaPricingPage;